import {streamify} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @class
 * @implements UseCase
 */
@streamify('execute')
class GetPendingPtaUseCase extends UseCase {
  /**
   * @constructor
   * @param {Object} deps
   * @param {Service} deps.getPendingPtaService
   */

  constructor({getPendingPtaService}) {
    super()
    this._getPendingPtaService = getPendingPtaService
  }

  execute() {
    return this._getPendingPtaService.execute().then(pendingPtaVO => pendingPtaVO.toJSON().pendingPta)
  }
}

export default GetPendingPtaUseCase
